module.exports = __webpack_public_path__ + "static/img/pop_up_prize.4818423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/popup/pop_up_prize.png
// module id = yagy
// module chunks = 1